export const reservasModals = {
  roomChange: {
    close: "إغلاق",
    titleAssign: "تعيين غرفة",
    titleChange: "تغيير الغرفة",
    stopSoldNote:
      "هذا النوع من الغرف مغلق للبيع في هذه التواريخ (إيقاف البيع)، لكن لا يزال بإمكانك إعادة تنظيم الغرف: النقل أو التعيين لا يعيد فتح البيع.",
    labelAssign: "الغرفة المراد تعيينها",
    labelNew: "غرفة جديدة",
    selectPlaceholder: "اختر غرفة…",
    swapWith: "التبديل مع {names}",
    swapWithType: "التبديل مع {names} (ينتقل إلى {type})",
    swapTypeWarning: "بعد التبديل ينتقل {names} إلى {type}، وهو ليس النوع الذي حجزه.",
    swapGroup:
      "تبديل جماعي: ينتقل {name} و{also} إلى تلك الغرفة، وينتقل {incoming} إلى غرفتك. كل ذلك في عملية واحدة.",
    swapSingle:
      "هذه الغرفة يشغلها {names}. عند الحفظ سيتم {action}: ينتقل حجزك إلى تلك الغرفة وتنتقل الغرفة (الغرف) الأخرى إلى غرفتك.",
    swapWord: "التبديل",
    emptyNote:
      "لا توجد غرفة متاحة طوال الفترة بأكملها. استخدم زر {action} في مسار «للتنظيم» لإعادة ترتيب الحجوزات تلقائيًا.",
    organizeWord: "تنظيم",
    sameTypeGroup: "النوع نفسه · {name}",
    otherTypeGroup: "نوع آخر · {name}",
    typeChangeNote:
      "سينتقل الحجز إلى {type}. يتم تحديث بياناته وإعادة حساب التوافر للنوعين وإبلاغ القنوات.",
    selectRoomError: "يجب اختيار غرفة",
    cancel: "إلغاء",
    confirmSwap: "تبديل",
    confirmAssign: "تعيين",
    confirmSave: "حفظ التغيير",
  },
  outOfOrder: {
    titleMaintenance: "صيانة الغرفة",
    titleActions: "إجراءات نوع الغرفة",
    scopeLabel: "النطاق",
    scopeUnit: "النوع (الكل)",
    scopeInstance: "هذه الغرفة",
    actionLabel: "الإجراء",
    actionOoo: "خارج الخدمة (صيانة)",
    actionOpen: "إعادة الفتح في الفترة",
    quantityLabel: "عدد الغرف",
    maxPerDay: "بحد أقصى {max} يوميًا.",
    dateRangeLabel: "نطاق التواريخ",
    from: "من",
    to: "إلى",
    cancel: "إلغاء",
    apply: "تطبيق",
  },
  closeDay: {
    title: "تغيير التوفر",
    syncing: "جارٍ مزامنة التوفر...",
    roomTypeLabel: "نوع الغرفة",
    roomTypePlaceholder: "اختر غرفة",
    startDate: "تاريخ البدء",
    endDate: "تاريخ الانتهاء",
    maxAvailable: "الحد الأقصى: {count} متاح",
    cancel: "إلغاء",
    apply: "تطبيق التغيير",
  },
  confirm: {
    defaultTitle: "تأكيد؟",
    confirm: "تأكيد",
    cancel: "إلغاء",
  },
  updateAlert: {
    title: "تحديث الغرفة",
    sectionTitle: "معلومات الغرفة",
    nameLabel: "اسم الغرفة أو رقمها",
    keyLabel: "مفتاح الدخول",
    cancel: "إلغاء",
    submit: "تحديث الغرفة",
    nameRequired: "اسم الغرفة أو رقمها مطلوب",
  },
};
